<template>
  <Teleport to="body">
    <Transition name="ui-drawer">
      <div
        v-if="modelValue"
        v-dialog-focus="{ onEscape: close }"
        class="ui-drawer"
        :class="$attrs.class"
        role="dialog"
        aria-modal="true"
        aria-label="Меню"
        @click.self="close"
      >
        <div
          class="ui-drawer__panel"
          :class="{ 'ui-drawer__panel--right': position === 'right' }"
          :style="{ width: width }"
        >
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { vDialogFocus } from '@/shared/lib/dialogFocus'
defineOptions({ inheritAttrs: false })

withDefaults(
  defineProps<{
    modelValue: boolean
    width?: string
    position?: 'left' | 'right'
  }>(),
  { width: '300px', position: 'left' },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'close'): void
}>()

function close() {
  emit('update:modelValue', false)
  emit('close')
}
</script>

<style scoped>
.ui-drawer {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0.4);
}

.ui-drawer__panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
}

.ui-drawer__panel--right {
  left: auto;
  right: 0;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
}

.ui-drawer-enter-active,
.ui-drawer-leave-active {
  transition: opacity 0.2s ease;
}
.ui-drawer-enter-from,
.ui-drawer-leave-to {
  opacity: 0;
}
.ui-drawer-enter-active .ui-drawer__panel,
.ui-drawer-leave-active .ui-drawer__panel {
  transition: transform 0.2s ease;
}
.ui-drawer-enter-from .ui-drawer__panel,
.ui-drawer-leave-to .ui-drawer__panel {
  transform: translateX(-100%);
}
.ui-drawer-enter-from .ui-drawer__panel--right,
.ui-drawer-leave-to .ui-drawer__panel--right {
  transform: translateX(100%);
}
.ui-drawer-enter-active .ui-drawer__panel--right,
.ui-drawer-leave-active .ui-drawer__panel--right {
  transform: translateX(0);
}
</style>
